<template>
  <div>
    <el-tabs
      v-if="salesLeadStatusCount"
      v-model="activeStatus"
      @tab-click="handleClick"
      >
      <el-tab-pane
        v-for="statusObj in statusArr"
        :label="
          statusObj.label +
          (salesLeadStatusCount[statusObj.fieldNum]
            ? `(${salesLeadStatusCount[statusObj.fieldNum]})`
            : '(0)')
        "
        :name="statusObj.field"
        :key="statusObj.field"
      />
    </el-tabs>
    <div class="notifyMsg" v-if="activeStatus === 'recovery'">
      注意:
      已回收线索为聚合招募渠道的限时回收类型线索，线索在创建后48小时内未产生跟进记录，系统将做回收处理，并根据前一天的限时回收线索跟进率进行重新分配。线索跟进率=
      完成跟进线索数/分发线索数
    </div>
    <base-list-management
      ref="baseListManagement"
      :configData.sync="configData"
      >
      <PublicExport
        slot="custom-export"
        v-if="judgePermission('rent_car_clue_sales_export')"
        exportTitle="销售线索导出"
        exportTemplate="SalesLeadList"
        :getSearchData="searchParams"
        templateCode="vehicle-customer-clue"
        :getSearchCondition="getSearchCondition"
        >
        <template v-slot:export-button="{ openDialog, exportBtnText }">
          <el-tooltip
            effect="dark"
            content="系统分配线索不支持数据导出"
            >
            <el-button
              @click="openDialog"
              >
              {{ exportBtnText }}
              <i class="el-icon-warning el-icon--right"></i>
            </el-button>
          </el-tooltip>
        </template>
      </PublicExport>
      <div slot="custom-operate">
        <el-button
          type="primary"
          @click="showQRCode"
          >
          领取线索
        </el-button>
        <el-button
          @click="addNewClue"
          v-if="judgePermission('rent_car_clue_sales_add')"
          >
          新建线索
        </el-button>
        <el-button
          @click="batchImportClue"
          v-if="judgePermission('rent_car_clue_sales_batch_import')"
          >
          导入线索
        </el-button>
      </div>
    </base-list-management>
    <FollowupDialog ref="followupDialog" :data="currRowData" />
    <el-dialog
      :visible.sync="dialogInfo.visible"
      :title="dialogInfo.title"
      width="550px"
      >
      <component
        :is="dialogInfo.type"
        :dialogVisible="dialogInfo.visible"
        @success="saveSuccess"
        @closeDialog="closeDialog"
      />
    </el-dialog>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import isNil from 'lodash/isNil'
import isString from 'lodash/isString'
import omitBy from 'lodash/omitBy'
import set from 'lodash/set'
import moment from 'moment'
// eslint-disable-next-line import/no-cycle
import {
  getSalesLeadList,
  getSalesLeadStatusCount,
} from '@/api/domain/orders'

import { operateMaxShowLength } from '@/store/dict/config'
import { quick } from '@/utils/ba'
import { generateExportCondition } from '@/utils/exportUtils.js'
import AddClueContent from '../components/addClueContent.vue'
import FollowupDialog from '../components/followupDialog.vue'
import ImportClueContent from '../components/importClueContent.vue'
import { STATUS_ARR, STATUS_ENUM } from '../constant'
import { getFormItemListConfig, getTableColumnsConfig } from './config'
import { trackClick } from '@/utils/trackReport'

export default {
  components: {
    FollowupDialog,
    AddClueContent,
    ImportClueContent,
  },
  data() {
    return {
      activeStatus: 'all',
      statusArr: STATUS_ARR,
      salesLeadStatusCount: null,
      configData: {
        formData: {
          list: [],
          formProps: {
            model: {},
          },
          dealWithSearch: this.filterParams,
        },
        tableData: {
          columns: [
            ...getTableColumnsConfig(this),
            {
              name: 'operate',
              columnProps: {
                label: '操作',
                fixed: 'right',
                width: 140,
              },
              maxShowLength: operateMaxShowLength,
              type: 'operate',
              getOperateList: this.getOperateList,
            },
          ],
          pagination: {
            pageSizes: [10, 20, 30, 50],
          },
          apiFn: getSalesLeadList,
          // 预留配置 线索状态
          defaultParams: {},
        },
        isShowDepartment: false,
      },
      curLeadId: -1,
      currRowData: null,
      dialogInfo: {
        type: '',
        title: '',
        visible: false,
      },
    }
  },
  created() {
    this.handleInit()
  },
  methods: {
    searchParams() {
      const params = this.$refs.baseListManagement?.getParams()
      const currentItem = STATUS_ARR.find((item) => item.field === this.activeStatus)
      return {
        ...params,
        state: currentItem.value,
      }
    },
    handleInit() {
      const { tabStatus, storeId } = this.$route.query

      if (tabStatus) {
        this.activeStatus = tabStatus
        const statusItemObj = STATUS_ARR.find((item) => item.field === tabStatus)
        if (statusItemObj) {
          this.configData.tableData.defaultParams.state = statusItemObj.value
        }
      }
      if (storeId) {
        this.configData.formData.formProps.model.storeId = storeId
      }
      this.configData.formData.list = getFormItemListConfig(this)
      this.reloadGetSalesLeadStatusCount()
      // 兼容新线索管理和销售线索管理两个页面，如果没有线索管理导出按钮的权限，判断是否有销售线索管理导出按钮的权限
      if (
        !this.judgePermission('rent_car_clue_sales_export') &&
        this.judgePermission('rent_car_clue_export')
      ) {
        this.configData.formData.exportData.permissionName =
          'rent_car_clue_export'
      }
    },
    reloadGetSalesLeadStatusCount() {
      getSalesLeadStatusCount()
        .then((res) => {
          if (res.code === 1) {
            this.salesLeadStatusCount = res.data
          } else {
            throw new Error(`销售线索状态统计接口--code:${res.code}`)
          }
        })
        .catch(() => {
          this.salesLeadStatusCount = {}
        })
    },
    handleClick({ name }) {
      const currentItem = STATUS_ARR.find((item) => item.field === name)
      if (currentItem.value > -1) {
        this.configData.tableData.defaultParams.state = currentItem.value
      } else {
        delete this.configData.tableData.defaultParams.state
      }
      // 重置搜索表单 建议 rest 改为 restSearchForm
      // 方法两个指责，不单一 restSearchForm And reloadTableData
      this.$refs.baseListManagement.reset()
    },
    getOperateList({ row }) {
      const followingBtn = {
        name: ['rent_car_clue_sales_follow'],
        label: '跟进',
        action: () => this.handleFollowingBtnClick(row),
      }
      const signAContractToPickUpTheCarBtn = {
        name: 'for_rent_sign_contract_rent_order_create',
        label: '签约提车',
        action: () => this.handleSignAContractToPickUpTheCarBtnClick(row),
      }
      const currentItem = STATUS_ARR.find((item) => item.label === row.state)
      // 如果出现了枚举值以外的状态值，即currentItem为null
      // 该条数据正常显示，只是后面的操作项为空（没有任何操作按钮）
      if (!currentItem) return
      if (currentItem.value <= STATUS_ENUM.ARRIVED) {
        return this.permissionFilter([
          followingBtn,
          signAContractToPickUpTheCarBtn,
        ])
      }
      return this.permissionFilter([])
    },
    /**
     * 调用全局 mixins 过滤操作按钮是否展示
     * @param {操作按钮 Array} btnObjArr
     */
    permissionFilter(btnObjArr) {
      return btnObjArr.filter((item) => {
        if (Array.isArray(item.name)) {
          return item.name.reduce(
            (flag, name) => flag || this.judgePermission(name),
            false,
          )
        }
        return this.judgePermission(item.name)
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    handleDetailBtnClick(row) {
      // 如果有线索管理页面的权限，跳转到新定义的详情页
      if (this.judgePermission('rent_car_clue_sales_detail')) {
        this.$router.push({
          path: '/car_to_lease/salesClue/detail',
          query: {
            id: row.id,
          },
        })
      } else {
        this.$router.push({
          path: '/car_to_lease/salesLeadManagement/detail',
          query: {
            id: row.id,
          },
        })
      }
    },
    handleFollowingBtnClick(row) {
      // 跟进按钮点击回调
      // 1. 弹出线索跟进表单弹窗
      this.currRowData = row
      this.curLeadId = row.id
      this.$nextTick(() => {
        this.$refs.followupDialog?.showDialog(row)
      })
      quick('click', 'sales_clue_add_record')
      trackClick('sales_clue_add_record')
    },
    // config.js 有调用
    // eslint-disable-next-line vue/no-unused-properties
    handleLeadIdInputEvent(val) {
      set(this.configData.formData, 'formProps.model.id', val)
    },
    // config.js 有调用
    // eslint-disable-next-line vue/no-unused-properties
    handlePhoneInputEvent(val) {
      set(this.configData.formData, 'formProps.model.phone', val)
    },
    async handleSignAContractToPickUpTheCarBtnClick(row) {
      quick('click', 'sales_clue_pick_up_car')
      trackClick('sales_clue_pick_up_car')
      // 签约提车按钮点击回调
      // 跳转签约提车 携带手机号 姓名
      const { id: leadId, phone: leadPhone, name: leadName } = row
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/personalSignContract',
        query: {
          leadId,
          leadPhone,
          leadName,
        },
      })
    },
    filterParams(params) {
      const needFilterDateKey = ['gmtCreate', 'followTime', 'nextFollowTime']
      const cloneParams = cloneDeep(params)
      // 过滤 无效字段 null  undefined ‘’
      const newObj = omitBy(cloneParams, (value) => {
        if (isNil(value)) {
          return true
        }
        if (Array.isArray(value) && value.length === 0) {
          return true
        }
        if (value === '') {
          return true
        }
        return false
      })
      // 过滤 日期 [2022-01-01, 2022-02-02] 转为 start: 2022-01-01, end: 2022-02-02
      for (const key in newObj) {
        if (Object.hasOwnProperty.call(newObj, key)) {
          const element = newObj[key]
          if (
            Array.isArray(element) &&
            element.length === 2 &&
            needFilterDateKey.includes(key)
          ) {
            const startTime = element[0]
            const endTime = element[1]
            if (
              !isNil(startTime) &&
              !isNil(endTime) &&
              isString(startTime) &&
              isString(endTime)
            ) {
              if (moment(startTime).isValid() && moment(endTime).isValid()) {
                newObj[`${key}Start`] = startTime
                newObj[`${key}End`] = endTime
              }
            }
          }
        }
      }
      return newObj
    },
    // 点击 新建线索 按钮
    addNewClue() {
      this.dialogInfo.visible = true
      this.dialogInfo.type = 'AddClueContent'
      this.dialogInfo.title = '新建线索'
    },
    // 点击 导入线索 按钮
    batchImportClue() {
      this.dialogInfo.visible = true
      this.dialogInfo.type = 'ImportClueContent'
      this.dialogInfo.title = '导入线索'
    },
    // 新建线索/导入线索弹窗，成功回调
    // 弹窗消失，列表刷新
    saveSuccess() {
      this.dialogInfo.visible = false
      this.$refs.baseListManagement.searchForm('table')
      this.reloadGetSalesLeadStatusCount()
    },
    closeDialog() {
      this.dialogInfo.visible = false
      this.dialogInfo.type = ''
    },
    getSearchCondition() {
      const params = this.$refs.baseListManagement.getParams()
      // input和日期没有值时不展示，其他没有值时展示全部
      const condition = this.configData.formData.list.map((item) => {
        const {
          el,
          itemConfig: { label, prop: key },
        } = item
        const val = params[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      condition.push({
        label: '线索状态',
        matchValue: this.statusArr.find((item) => item.field === this.activeStatus)?.label,
      })
      return condition
    },
    // 显示线索大厅二维码弹窗
    showQRCode() {
      this.$refs.followupDialog?.showDialog()
    },
  },
}
</script>

<style lang="scss" scoped>
.notifyMsg {
  font-size: 14px;
  color: red;
  margin-bottom: 5px;
}
::v-deep .clue-qrcode-dialog {
  .el-dialog__header {
    display: none;
  }
  .content {
    margin-top: 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.9);
    .img {
      width: 220px;
      height: auto;
      margin-bottom: 20px;
    }
  }
  .el-dialog__scrollerBody {
    padding-bottom: 44px;
  }
  .el-dialog__footer {
    border-top: 1px solid #E7E8EB;
    padding: 12px 0;
  }
}
</style>
